import {Component, input, OnDestroy} from '@angular/core';
import {
    ControlValueAccessor,
    FormBuilder,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    TouchedChangeEvent,
    ValidationErrors,
    Validator,
    Validators
} from '@angular/forms';
import {Input, InputConnection} from '../model/plowops-pro-models';
import {MatError, MatFormField} from '@angular/material/form-field';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {MatOption, MatSelect} from '@angular/material/select';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';

@Component({
    selector: 'app-input-connection-configuration',
    imports: [
        MatFormField,
        ReactiveFormsModule,
        MatError,
        MatSelect,
        MatOption,
        MatButtonToggleGroup,
        MatButtonToggle,
    ],
    templateUrl: './input-connection-configuration.component.html',
    styleUrls: ['../../../../settings-fields.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: InputConnectionConfigurationComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: InputConnectionConfigurationComponent
        },
    ]
})
export class InputConnectionConfigurationComponent implements ControlValueAccessor, Validator, OnDestroy {

    connection: InputConnection;

    label = input<string>('Input');

    formGroup: FormGroup;

    subscriptions: Subscription[] = [];

    availableInputs = input<Input[]>();

    isTwoWire = input<boolean>(false);

    constructor(fb: FormBuilder) {
        this.formGroup = fb.group({
            inputNumber: fb.control(null, {validators: Validators.required}),
            reversed: fb.control(false),
            bluetooth: fb.control(false)
        });

        this.subscriptions.push(
            this.formGroup.valueChanges.subscribe(value => {
                this.onChangeListener(value as InputConnection);
            })
        );

        this.subscriptions.push(
            this.formGroup.events.pipe(
                filter(e => e instanceof TouchedChangeEvent && e.touched)
            ).subscribe(() => this.onTouchedListener())
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    writeValue(obj: InputConnection) {
        const {inputNumber, reversed, bluetooth} = obj || {};
        this.formGroup.setValue({
            inputNumber: inputNumber || null,
            reversed: reversed || false,
            bluetooth: bluetooth || false
        });
    }

    onChangeListener = _ => {
    }

    onTouchedListener = () => {
    }

    onValidatorChange = () => {
    }

    registerOnChange(fn: any) {
        this.onChangeListener = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedListener = fn;
    }

    setDisabledState(isDisabled: boolean) {
        if (isDisabled) {
            this.formGroup.disable({emitEvent: false});
        } else {
            this.formGroup.enable({emitEvent: false});
        }
    }

    registerOnValidatorChange(fn: () => void) {
        this.onValidatorChange = fn;
    }

    validate(_: FormGroup): ValidationErrors | null {
        if (this.formGroup.invalid) {
            return {_control: {invalid: true}};
        }
        return null;
    }
}
